<template>
    <div
        class="SystemItemActivity"
        :class="{ locked, '--global-clickable': !locked, pulsate, completed: progress === 1 }"
        @click.stop="!locked && $emit('click')"
    >
        <svgicon class="icon" :icon="activity.icon" />
    </div>
</template>

<script>
export default {
    props: {
        activity: {
            type: Object,
            required: true,
            default: () => {}
        },
        locked: {
            type: Boolean,
            default: false
        },
        progress: {
            type: Number,
            default: 0
        },
        pulsate: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        step() {
            return this.$store.state.moduleCourse.steps[this.stepId];
        },
        activities() {
            return this.step.activityNames.map(name => this.step[name]);
        }
    },

    methods: {
        // startPractice() {
        //     this.$store.commit('moduleApp/setSystemExitTo', this.$route.path);
        //     this.$router.push({
        //         name: 'MemogeniusSystem',
        //         params: {
        //             systemId: this.systemId
        //         }
        //     });
        // }
    }
};
</script>

<style lang="scss" scoped>
$normalBgColor: mix(black, white, 5%);
$normalFillColor: black;

$completedBgColor: mix($completionColor, white, 10%);
$completedFillColor: $completionColor;

$itemSize: 2.2em;

.SystemItemActivity {
    $size: $itemSize;
    width: $size;
    height: $size;
    border-radius: 50%;
    background-color: $normalBgColor;
    transition: transform 0.3s;
    backface-visibility: hidden; // NOTE: Might help to reduce pixel bugs at end of transform
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 530px) {
        width: 28px;
        height: 28px;
    }

    &.completed {
        background-color: $completedBgColor;
        .svg-icon {
            fill: $completedFillColor;
        }
    }

    &.locked {
        opacity: 0.2;
    }

    &:not(.locked):hover {
        transform: scale(1.2);
    }
}

.svg-icon {
    $size: 1em;
    width: $size;
    height: $size;
    fill: $normalFillColor;

    @media (max-width: 530px) {
        width: 13px;
        height: 13px;
    }
}
</style>
